<template>
  <div>
    <div class="detail-container">
      <h2 class="detail-title">基本信息</h2>
      <div class="detail-info" style="margin-bottom: 18px">
        <el-row>
          <el-col :span="12">
            <div class="label">所属分类：</div>
            <div class="text">
              {{ productDetailForm.categoryName }}
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <div class="label">商品名称：</div>
            <div class="text">
              {{ productDetailForm.skuName }}
            </div>
          </el-col>
          <el-col :span="12">
            <div class="label">商品编号：</div>
            <div class="text">{{ productDetailForm.skuCode }}</div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <div class="label">供货周期：</div>
            <div class="text">{{ productDetailForm.leadTime }}天</div>
          </el-col>
          <el-col :span="12">
            <div class="label">产品特色：</div>
            <div class="text">{{ productDetailForm.uniqueFeature }}</div>
          </el-col>
        </el-row>
      </div>
      <div v-if="productDetailForm.imageUrls.length" class="detail-info" style="margin-top: 16px">
        <h3 class="detail-info-title">商品图片</h3>
        <div class="images-content">
          <div v-for="item in productDetailForm.imageUrls" :key="item" class="images-item">
            <img :src="item" width="124" height="124" />
          </div>
        </div>
      </div>
      <div class="detail-info">
        <h3 class="detail-info-title">属性参数范围</h3>
        <div style="margin-left: 20px">
          <el-row>
            <el-col v-for="item in productDetailForm.attributes" :key="item.skuAttributeId" :span="12">
              <div class="label">{{ `${item.attributeName}：` }}</div>
              <div class="text">{{ item.attributeValue }}</div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

    <div class="detail-container">
      <h2 class="detail-title">结构图纸</h2>
      <div class="detail-content">
        <img v-for="item in productDetailForm.constructionImageUrls" :key="item" alt="" :src="item" />
      </div>
    </div>

    <div class="detail-container">
      <h2 class="detail-title">性能参数</h2>
      <div class="detail-content">
        <!-- constructionImageUrls构造，propertyImageUrls性能 -->
        <img v-for="item in productDetailForm.propertyImageUrls" :key="item" alt="" :src="item" />
      </div>
    </div>

    <div class="detail-container">
      <h2 class="detail-title">资料下载</h2>
      <!-- skuFiles -->
      <div class="detail-content">
        <ETableList :table-data="productDetailForm.skuFiles" :table-label="tableLabel">
          <template #operate="{ scope: { row } }">
            <eui-btn font-size="12px" type="link" @click="uploadDesc(row.fileUrl, row.fileName)">下载</eui-btn>
          </template>
        </ETableList>
      </div>
    </div>

    <div class="submit-button">
      <eui-btn @click="goBack">返回</eui-btn>
    </div>
  </div>
</template>

<script>
import Api from '@/modules/projectA/api/product/index';
import ETableList from '@/modules/projectA/components/common/e-table-list.vue';

export default {
  components: { ETableList },
  props: {
    productAuditId: {
      type: Number,
      default: 0,
    },
    ifDetail: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      btnLoading: false,
      productDetailForm: { skuFiles: [] },
      auditForm: { auditStatus: '101', approvalOpinion: '' },
      auditRules: {
        auditStatus: [{ required: true, message: '请选择审核状态', trigger: 'change' }],
        approvalOpinion: [{ required: true, message: '请填写拒绝原因', trigger: 'blur' }],
      },
      tableLabel: [
        {
          label: '附件名称',
          param: 'fileName',
          align: 'center',
        },
        {
          label: '操作',
          width: '160',
          align: 'center',
          slot: 'operate',
          fixed: 'right',
        },
      ],
    };
  },
  computed: {},
  mounted() {
    const { productAuditId, skuId } = this.$route.query;
    skuId && this.getSkuIdProductDetail(skuId);
    productAuditId && this.getAuditProductDetail(productAuditId);
  },
  methods: {
    async getAuditProductDetail(productAuditId) {
      const { queryReleaseProductInfoById } = Api;
      try {
        this.productDetailIng = true;
        const result = await queryReleaseProductInfoById({
          productAuditId,
        });
        console.log(result, 'resultresult');
        if (result.code === '200') {
          this.productDetailForm = {
            ...result.data.productVO,
            ...result.data.productVO.skus[0],
          };

          this.getSupplierInfo();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getSkuIdProductDetail(skuId) {
      const { getCompanyOffStandardSkuInfo } = Api;
      try {
        this.productDetailIng = true;
        const res = await getCompanyOffStandardSkuInfo({ skuId });
        this.productDetailIng = false;
        if (res.code === '200') {
          const data = res.data?.skus[0];
          this.productDetailForm = { ...this.productDetail, ...data };
          console.log(this.productDetailForm);
        }
      } catch (error) {
        console.log(error);
      }
    },

    uploadDesc(fileUrl, fileName = '下载文件') {
      // 通过 url 下载文件并给文件重新起名字
      const downloadRes = async () => {
        const response = await fetch(fileUrl); // 内容转变成blob地址
        const blob = await response.blob(); // 创建隐藏的可下载链接
        const objectUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = fileName;
        a.click();
        a.remove();
      };
      downloadRes();
    },

    goBack() {
      this.$store.state.tagsList.forEach((item, index) => {
        if (item.fullPath === this.$route.path) {
          this.$store.state.tagsList.splice(index, 1);
        }
      });
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.detail-container {
  margin-bottom: 20px;
  padding: 20px;
  color: #333;
  background: #fff;
  .detail-title {
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
  }
  .detail-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;
    img {
      display: block;
      flex: none;
    }
  }
  .detail-info {
    font-size: 14px;
    ::v-deep .el-row {
      margin-left: 28px;
      .el-col {
        display: flex;
        margin-top: 12px;
        .label {
          white-space: nowrap;
        }
      }
    }
    .detail-info-title {
      height: 40px;
      padding-left: 20px;
      font-size: 14px;
      font-weight: 500;
      line-height: 40px;
      background: #f5f5f5;
    }
    .images-content {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 10px;
      .images-item {
        margin: 10px 10px 0 0;
        img {
          display: block;
        }
      }
    }
  }
}
.submit-button {
  margin: 20px 0 30px 0;
  text-align: center;
}
</style>
